"use client";
import { useEffect } from "react";

interface ViewItemAnalyticsProps {
  title?: string;
  tourSlug?: string;
}

export default function ViewItemAnalytics({
  title,
  tourSlug,
}: ViewItemAnalyticsProps) {
  useEffect(() => {
    if (typeof window === "undefined") return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        currency: "EUR",
        items: [
          {
            item_name: title || "",
            item_id: tourSlug || "",
            item_category: "Zájazd",
          },
        ],
      },
    });
  }, [title, tourSlug]);

  return null;
}
